import { configure } from 'mobx';

import { RootStoreMobx } from './RootStoreMobx';

configure({
  // The goal of enforceActions is that you don't forget to wrap event handlers in action
  enforceActions: 'never', // Disable action enforcement warnings
});

export const mobx = new RootStoreMobx();
